import AbstractPlatformWindow, {
    PlatformWindowGetSizeResponse
} from "~/operatorApplication/ts/platform/AbstractPlatformWindow";
import {ElectronIPCRendererInstance} from "~/ts/library/electron/ipc/ElectronIPCRenderer";
import {
    OPERATOR_ELECTRON_IPC_FOCUS_WINDOW_ACTION,
    OPERATOR_ELECTRON_IPC_GET_WINDOW_SIZE_ACTION,
    OPERATOR_ELECTRON_IPC_MINIMIZE_WINDOW_ACTION,
    OPERATOR_ELECTRON_IPC_MOVE_WINDOW_ACTION,
    OPERATOR_ELECTRON_IPC_OPEN_DEV_TOOLS_ACTION,
    OPERATOR_ELECTRON_IPC_RESIZE_WINDOW_ACTION,
    OPERATOR_ELECTRON_IPC_UPDATE_BADGE_ACTION
} from "~/operatorApplication/electron/src/ipc/ElectronIpcActionsConstant";
import ElectronIpcResizeWindowRequestInterface
    from "~/operatorApplication/electron/src/ipc/ElectronIpcResizeWindowRequestInterface";
import ElectronIpcMoveWindowRequestInterface
    from "~/operatorApplication/electron/src/ipc/ElectronIpcMoveWindowRequestInterface";
import Delay from "~/ts/library/Delay";

//const {ipcRenderer} = require('electron')

export default class ElectronPlatformWindow extends AbstractPlatformWindow {
    isFocusAvailable() {
        return true;
    }

    async resize(width: number, height: number, center: boolean = true, maximized: boolean = false): Promise<void> {
        let data: ElectronIpcResizeWindowRequestInterface = {
            width,
            height,
            maximized
        };
        await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_RESIZE_WINDOW_ACTION, data);
        if (center) {
            await this.center();
        }
    }

    async minimize(): Promise<void> {
        await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_MINIMIZE_WINDOW_ACTION);
    }

    async move(x: number, y: number): Promise<void> {
        let data: ElectronIpcMoveWindowRequestInterface = {
            x,
            y
        };
        await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_MOVE_WINDOW_ACTION, data);
    }

    async getSize(): Promise<PlatformWindowGetSizeResponse> {
        return await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_GET_WINDOW_SIZE_ACTION);
    }

    async openDevTools(): Promise<void> {
        return await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_OPEN_DEV_TOOLS_ACTION);
    }

    async setBadge(value?: number) {
        try {
            await Delay.make(100, "setBadge", true);
            ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_UPDATE_BADGE_ACTION, value);
        } catch (e) {
        }
    }

    focus() {
        ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_FOCUS_WINDOW_ACTION);
    }

    setIcon(icon: string) {
        //ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_IPC_SET_WINDOW_ICON_ACTION, icon);
    }
}